import { render, staticRenderFns } from "./CommunityDirectoryPage.vue?vue&type=template&id=63905442&scoped=true&"
import script from "./CommunityDirectoryPage.vue?vue&type=script&lang=js&"
export * from "./CommunityDirectoryPage.vue?vue&type=script&lang=js&"
import style0 from "./CommunityDirectoryPage.vue?vue&type=style&index=0&id=63905442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63905442",
  null
  
)

export default component.exports